import React from "react" 
import { Button, Icon, Radio } from "antd"

export const Distributor = ({ id, company, mail, address, fullName, phone, additional_phone, className, onChange, onClick })=> (    
    <Radio className={className} value={id} onChange={onChange}>
        {className ? <span className="distributors__error">Это обязательное поле</span> : null}
        
        <span className="distributors__name">{company}</span>
        <Button className="distributors__text" onClick={onClick} type="link">
            <Icon type="environment" />
            {address}
        </Button>
        { 
            fullName && 
            <span className="distributors__text">
                <Icon type="user" />
                {fullName}
            </span>
        }
        
        {
            mail &&
            <a href={"mailto:"+ mail} className="distributors__text">
                <Icon type="mail" />
                {mail}
            </a>
        }


        {
            phone &&
            <div className="distributors__row">
                <a href={"tel:"+phone} className="distributors__text">
                    <Icon type="phone" className="distributors__tel"/>
                    {phone}
                </a>

                {additional_phone && 
                <a href={"tel:"+phone.slice(0, 12) + additional_phone} className="distributors__text">
                    <Icon type="phone" className="distributors__tel"/>
                    {additional_phone}
                </a>}
            </div>
        }

    </Radio>
)


// WEBPACK FOOTER //
// ./src/components/pages/projects/distributors/distributorsList/Distributor.js